import { DocumentVersionInfo } from "@/mocks/data/documentVersionService/documentVersion";
const documentVersion = {
    getDocumentVersionData: async (): Promise<any> =>{
        try {
        // const resp = await axios.get(`/packaging-service/api/v1/packaging/${vendorId}`)
        const resp = DocumentVersionInfo;
        return resp ? resp : null;
        } catch (error) {
            console.error("Error fetching document version data:", error);
            throw error;
        }
    }
};
 
export default documentVersion;